import styled from '@emotion/styled';

import MultipleIcon from '@/assets/icons/icon_multiple.svg';
import SingleIcon from '@/assets/icons/icon_single.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Text = styled.span(() =>
  mq({
    display: 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    wordBreak: 'break-word',
    fontFamily: defaultTheme.font.family.bicycleNumber,
    fontWeight: 'bold',
  }),
);

export const SingleSeparator = styled.i(() =>
  mq({
    width: '8px',
    height: '2px',
    backgroundImage: `url(${SingleIcon})`,
    margin: '0 2px',
  }),
);

export const MultiSeparator = styled.i(() =>
  mq({
    width: '8px',
    height: '6px',
    backgroundImage: `url(${MultipleIcon})`,
    margin: '0 2px',
  }),
);
